import React, { useMemo, useState } from 'react'
import { useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { addLocale } from 'primereact/api';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types'
import { DataTable } from 'primereact/datatable';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import dateFormat from '../../services/DateFormat.service';
import apis from '../../api';
import { useRef } from 'react';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import useWindowDimensions from '../hooks/useDimensions';
import {
    Calendar as BigCalendar,
    Views,
    DateLocalizer,
    momentLocalizer,
} from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toolbar as BigToolbar } from 'react-big-calendar/lib/Toolbar';
import InfoIcon from '../InfoIcon/InfoIcon';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './Home.css'
import { ScrollPanel } from 'primereact/scrollpanel';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { MultiSelect } from 'primereact/multiselect';
import { set } from 'lodash';
import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import { TablePaginator } from '../TablePaginator/TablePaginator';

require('moment/locale/es.js');

moment.locale('es');
let meses = 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_');
let semanas = 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_');
moment.updateLocale('es', { months: meses, weekdays: semanas });
const mLocalizer = momentLocalizer(moment)

const Home = ({
    localizer = mLocalizer,
    showDemoLink = true,
    ...props
}) => {

    const [fechaInicio, setFechaInicio] = useState(new Date(Date.now()))
    const [fechaInicioCalendario, setFechaInicioCalendario] = useState(new Date(Date.now()))
    const [novedadesCalendario, setNovedadesCalendario] = useState([])
    const [novedades, setNovedades] = useState([])
    const { width, height } = useWindowDimensions()

    const [loading1, setLoading1] = useState(false)
    const [consultado, setConsultado] = useState(0)
    const [loadPage, setLoadPage] = useState(false)

    const toast = useRef(null);
    const elementWidth = { width: "12rem" }
    const headers = {
        authorization: localStorage.getItem('token')
    }

    const [openModal, setOpenModal] = useState(false)
    const [novelty, setNovelty] = useState({})

    const showModal  = () => {
        setOpenModal(true)
    }

    const hideModal = () => {
        setOpenModal(false)
        setNovelty({})
    }

    let sixDate = new Date(Date.now())
    sixDate.setMonth(sixDate.getMonth() - 12)
    let initDate = new Date('2022-07-13')

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    const labelStyle = {
        // display: "block",
        // float: "left",
        marginTop: "5px",
        // width: "100%",
        paddingTop: "5px",
        // marginLeft: '-3rem'
    }

    /*Propiedades de la tabla del componente*/
    const [rowData, setRowData] = useState([]);
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [selectedRows, setSelectedRows] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [registros, setRegistros] = useState([]);

    const [type, setType] = useState([])
    const [listaTipoC, setListaTipoC] = useState([])

    const [filteredRows, setFilteredRows] = useState(rows);
    const [contractSearch, setContractSearch] = useState('');
    const [clientList, setClientList] = useState(false)
    const [entityList, setEntityList] = useState(false)
    const [client, setClient] = useState("")
    const [entity, setEntity] = useState("")

    const culture = {
        next: 'Siguiente',
        previous: 'Atrás',
        today: 'Hoy',
        showMore: (total) => `+${total} más`,
    }


    useEffect(() => {
        tableNov(fechaInicio)
    }, [])

    useEffect(() => {
        RenderCalendar()
    }, [consultado])

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }
    
    const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 100, value: 100 },
        { label: 200, value: 200 },
        { label: 500, value: 500 },
    ];

    const template2 = TablePaginator(dropdownOptions)
    
    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
                </IconField>
            </div>
        )
    }

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'JOB_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'DAY_CSO': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    const header1 = renderHeader1();

    const matchModes = [
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    const getReqLists = async (fecha) => {
        const startDate = dateFormat(fecha)
        try {
            await apis.calendarTypeList(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", startDate, headers).then(res => {
                let tipos = res.data.TYPE_NOVELTIES
                let types = []
                tipos.forEach(t => {
                    let newType = {
                        detail_id: t.TYPE.split('|')[0],
                        description: t.TYPE.split('|')[1],
                        ICON: t.ICON
                    }
                    types.push(newType)
                })
                setListaTipoC(types)
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    const splitMultiDayEvents = (events) => {
        const dailyEvents = [];

        events.forEach(event => {
            const start = moment(event.start);
            const end = moment(event.end);
            const startCopy = moment(event.start)
            if(end.diff(start, 'days') > 1){
                while (start.isSameOrBefore(end, 'day')) {
                    dailyEvents.push({
                        ...event,
                        start: start.toDate(),
                        end: start.clone().endOf('day').toDate(),
                        realStart: startCopy.toDate(),
                        realEnd: end.toDate(),
    
                    });
                    start.add(1, 'day');
                }
            }
            else{
                dailyEvents.push({
                    ...event,
                    realStart: startCopy.toDate(),
                    realEnd: end.toDate(),
                })
            }
        });

        return dailyEvents;
    };

    const getGraphInfo = async (fecha) => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _fechaInicio = fecha ? dateFormat(fecha) : ""
        const payload = {
            ENTITY: _entity,
            CLIENT: _client,
            START_DATE: _fechaInicio,
            CONTRACTS: ""
        }

        try {
            await apis.requestGraph(payload, headers).then(res => {
                let novedades = res.data.dataset
                let fechaArranque = res.data.GO_LIVE
                fechaArranque = invDateFormat(fechaArranque)
                let nov = []
                novedades.forEach(element => {
                    let newNov = element
                    newNov["start"] = invDateFormat(newNov["start"])
                    newNov["end"] = invDateFormat(newNov["end"])
                    nov.push(newNov)
                });
                nov = splitMultiDayEvents(nov)
                console.log("Calendario: ", nov)
                setNovedades(nov)
                setNovedadesCalendario(nov)
                setSelectedRows(nov)
                setLoading1(false)
                setConsultado(consultado + 1)
                setFechaInicioCalendario(fechaArranque)
                setLoadPage(true)
            })
        }
        catch (err) {
            setLoading1(false)
            setLoadPage(true)
            // setLoading2(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const tableNov = (fecha) => {
        setLoadPage(false)
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _fechaInicio = fecha ? dateFormat(fecha) : ""
        const _token = localStorage.getItem('token')

        const payload = {
            ENTITY: _entity,
            CLIENT: _client,
            START_DATE: _fechaInicio,
            TOKEN: _token
        }

        try {
            apis.getNovContracts(payload, headers).then(res => {
                let contracts = res.data.CONTRACTS
                let newContracts = []
                let entity_list = []
                let client_list = []
                contracts.forEach(con => {
                    let newContract = {
                        ...con,
                        FULL_CONTRACT: con.NAME + ' ' + con.CONTRACT_ID + ' ' + con.JOB_ID + ' ' + con.CLIENT_NAME + ' ' + con.ENTITY_NAME
                    }
                    let entityIndex = entity_list.findIndex(ent => ent.CODE === con.ENTITY)
                    if(entityIndex !== -1){
                        let ent = entity_list[entityIndex]
                        let clients = [...ent.CLIENTS]
                        if(!ent.CLIENTS.some(cli => cli.CODE === con.CLIENT)){
                            let newClient = {
                                CODE: con.CLIENT,
                                NAME: con.CLIENT_NAME
                            }
                            clients.push(newClient)
                        }
                        ent = {
                            ...ent,
                            CLIENTS: [...clients]
                        }
                        entity_list[entityIndex] = ent
                    }
                    else{
                        let newClient = {
                            CODE: con.CLIENT,
                            NAME: con.CLIENT_NAME
                        }
                        let newEntity = {
                            CODE: con.ENTITY,
                            NAME: con.ENTITY_NAME,
                            CLIENTS: [newClient]
                        }
                        entity_list.push(newEntity)
                    }
                    newContracts.push(newContract)
                })
                setClientList(client_list)
                setEntityList(entity_list)
                setRows(newContracts)
                setFilteredRows(newContracts)
                setNovedadesCalendario([])
                setRegistros(newContracts)
                setLoading1(false)
                getGraphInfo(fecha)
                getReqLists(fecha)
            })
        }
        catch (err) {
            console.log(err)
            setLoading1(false)
        }
    }

    const onChange = (e) => {
        setRegistros(e.value)
        console.log(e.value)
        let news = []
        e.value.forEach(element => {
            let nov = novedades.filter((n) => n.CONTRACT_ID === element.CONTRACT_ID)
            nov.forEach(newNov => {
                news.push(newNov)
            })
        })
        console.log(novedadesCalendario)
        console.log(news)
        setNovedadesCalendario(news)
        setSelectedRows(news)
    }

    const applyFilters = (types_, contract_, entity_, client_) => {

        let filteredRows = [...rows];
    
        if (contract_) {
            filteredRows = filteredRows.filter(r =>
                r.FULL_CONTRACT.toLowerCase().includes(contract_.toLowerCase())
            );
        }
    
        if (entity_) {
            filteredRows = filteredRows.filter(r => r.ENTITY === entity_.CODE);
        }
    
        if (client_) {
            filteredRows = filteredRows.filter(r => r.CLIENT === client_.CODE);
        }
    
        let filteredCalendar = novedadesCalendario.filter(n =>
            filteredRows.some(r => r.CONTRACT_ID === n.CONTRACT_ID)
        );
    
        if (types_ && types_.length > 0) {
            filteredCalendar = filteredCalendar.filter(n =>
                types_.some(t => n.ICON === t.ICON)
            );
        }
    
        setFilteredRows(filteredRows);
        setSelectedRows(filteredCalendar);
    };

    const filterByType = (types) => {
        setType(types);
        applyFilters(types, contractSearch, entity, client);
    };

    const filterByContract = (contract) => {
        setContractSearch(contract);
        applyFilters(type, contract, entity, client);
    };

    const filterByEntity = (entity_) => {
        setEntity(entity_);
        setClient("")
        setClientList(entity_?.CLIENTS ? entity_.CLIENTS : [])
        applyFilters(type, contractSearch, entity_, entity_  ? client : undefined);
    };

    const filterByClient = (client_) => {
        setClient(client_);
        applyFilters(type, contractSearch, entity, client_ ? client_ : undefined);
    };

    const leftToolbarTemplate = () => {
        const msg = "Para filtrar la información, seleccione uno o varios tipos de novedades.\n Si lo desea, seleccione una empresa. Esto habilitará los clientes\n pertenecientes a dicha empresa y se podrá realizar el filtro por los 3 campos"
        const leftClassName = 'flex align-content-center gap-2 ' + (width > 768 ? 'flex-row' : 'flex-column')
        return (
            <div className={leftClassName}>
                <Tooltip target=".info" className='indigo-tooltip ml-1'/>
                <div className='flex flex-row align-items-center gap-2'>
                    <Calendar id="navigators" value={fechaInicio}
                        onChange={(e) => {
                            setFechaInicio(e.value);
                            setFechaInicioCalendario(e.value);
                            tableNov(e.value)
                        }}
                        locale="es" dateFormat="mm-yy" view='month' yearRange="1900:2150" showIcon style={elementWidth}
                        placeholder="Seleccione un mes" minDate={sixDate.getTime() <= fechaInicioCalendario.getTime() ? fechaInicioCalendario : sixDate}
                    />
                    <i className="info pi pi-info-circle cursor-pointer" data-pr-tooltip={msg} data-pr-position='bottom'
                        data-pr-classname="text-primary" style={{ color: '#00a8ff', fontSize: '1.2rem' }} />
                </div>
                <MultiSelect value={type} options={listaTipoC} onChange={(e) => filterByType(e.value)} optionLabel="description" itemTemplate={optionTemplate}
                    placeholder="Tipo novedades" style={{ width: '12rem' }} maxSelectedLabels={1} selectedItemsLabel='{0} tipos seleccionados' />
                <Dropdown value={entity} options={entityList} onChange={(e) => filterByEntity(e.value)} optionLabel="NAME" showClear
                    placeholder="Empresa" style={{ width: '12rem' }} tooltip={entity?.NAME} tooltipOptions={{position: 'top'}}/>
                <Dropdown value={client} options={clientList} onChange={(e) => filterByClient(e.value)} optionLabel="NAME" showClear disabled={!entity}
                    placeholder="Cliente" style={{ width: '12rem' }} tooltip={client?.NAME} tooltipOptions={{position: 'top'}}/>
                {type.length > 0 &&
                    <div>
                        {type.map(t => {
                            return (<i className={'mr-2 pi ' + t.ICON} />)
                        })}
                    </div>}
            </div>
        )
    }

    const rightToolbarTemplate = () => {
        return(
            <React.Fragment>
                <InputText type='search' placeholder='Buscar' tooltip='Filtrar por nombre, contrato, cargo, empresa o cliente' tooltipOptions={{position: 'left'}}
                style={{ width: '14rem' }} onChange={(e) => filterByContract(e.target.value)} />
            </React.Fragment>
        )
    }

    const photoBodyTemplate = (rowData) => {
        const photo = rowData.IMAGES ? rowData.IMAGES : process.env.REACT_APP_PROFILE_PIC;
        return (
            <div className='flex flex-row align-items-center justify-content-start gap-1'>
                <div
                    style={{
                        width: '50px',
                        height: '50px',
                        minWidth: '50px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        flexShrink: 0
                    }}
                >
                    <img
                        src={photo}
                        alt=""
                        loading="eager"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                </div>
                <div className='flex flex-column ml-2'>
                    <span className='font-bold'>{rowData.NAME}</span>
                    <span>{rowData.CONTRACT_ID} - {rowData.JOB_ID}</span>
                    <span><span className='font-bold'>Empresa: </span>{rowData.ENTITY_NAME}</span>
                    <span><span className='font-bold'>Cliente: </span>{rowData.CLIENT_NAME}</span>
                </div>
            </div>
        );
    }

    const { defaultDate, formats } = useMemo(
        () => ({
            // defaultDate: fechaInicio,
            formats: {
                weekdayFormat: (date, culture = 'ES', localizer) =>
                    localizer.format(date, 'dddd', culture),
            }
        }),
        []
    )

    const calendarEvent = (event) => {
        return (
            <span onClick={() => {
                setNovelty({...event.event})
                showModal()
            }}>
                <i className={'pi ' + event.event.ICON} style={{ color: "white", marginRight: '0.3rem' }} />
                {event.title}
            </span>
        )
    }

    const optionTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <i className={`mr-2 pi ` + option.ICON} style={{ width: '18px' }} />
                <div>{option.description}</div>
            </div>
        );
    };

    const RenderCalendar = () => {
        return (<div className='thing2' style={{ height: '50rem', backgroundColor: 'white', width: width > 960 && "70vw" }}>
            <BigCalendar
                culture='ES'
                messages={culture}
                // components={components}
                date={fechaInicio}
                events={selectedRows}
                formats={formats}
                localizer={localizer}
                showMultiDayTimes
                step={60}
                views={['month']}
                components={{ event: calendarEvent }}
                onNavigate={(date) => setFechaInicio(date)}
                style={{ width: '100%' }}
                eventPropGetter={event => ({
                    style: {
                        backgroundColor: event.COLOR,
                        maxWidth: '5.5rem',
                        borderRadius: '1rem',
                    },
                })}
            />
        </div>)
    }


    return (
        <div className='surface-100 px-4 py-5 md:px-6 lg:px-8r'>
            <Toast ref={toast} />
            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
                <span className="text-900">Resumen solicitudes</span>
            </div>
            <div className='mt-6 w-full'>
                <SkeletonTable load={loadPage}>
                    <Toolbar className='card flex flex-row w-full' start={leftToolbarTemplate} end={rightToolbarTemplate}/>
                    <div className="thing" style={{ display: 'flex' }}>
                        <Dialog visible={openModal} onHide={hideModal} closable draggable={false}>
                            <div className='flex flex-column align-items-center justify-content-center'>
                                <div className='flex flex-row align-items-center justify-content-center'>
                                    <div className='flex flex-column ml-2'>
                                        <span className='font-bold'>Contrato: {novelty.CONTRACT_ID}</span>
                                        <span className='font-bold'>Detalle: {novelty.title}</span>
                                        <span className='font-bold'>Inicio: {dateFormat(novelty.realStart)}</span>
                                        <span className='font-bold'>Fin: {dateFormat(novelty.realEnd)}</span>
                                    </div>
                                </div>
                            </div>
                        </Dialog>
                        <Tooltip target=".info" className='indigo-tooltip ml-1' />
                        <DataTable className="text-xs" value={filteredRows} first={first2} rows={rows2} scrollable scrollDirection='horizontal' scrollHeight="75vh" paginator paginatorTemplate={template2}
                            selectionMode="multiple" selection={registros} onSelectionChange={(e) => onChange(e)} dataKey="CONTRACT_ID" height='50rem'
                            size="small" style={{ width: width > 960 && "25vw", height: '75vh' }}>
                            <Column selectionMode="multiple" headerStyle={{ width: '3em' }} style={{ maxHeight: '75vh' }}></Column>
                            <Column field="FULL_CONTRACT" body={photoBodyTemplate} header='Empleados' style={{ maxHeight: '75vh' }}></Column>
                            <Column field="DAY_CSO" header="Días pendientes" style={{ maxHeight: '75vh' }}></Column>
                        </DataTable>
                        <RenderCalendar />
                    </div>
                </SkeletonTable>
            </div>
        </div>
    )

}
Home.propTypes = {
    localizer: PropTypes.instanceOf(DateLocalizer),
    showDemoLink: PropTypes.bool,
}

export default Home